module.exports = __webpack_public_path__ + "static/media/car-alt.e5f1ae90.svg";